import * as Yup from 'yup'
import { transformNumberValueAllowZero } from '../../../shared/transformNumberValue'
import { testNumberWithDotLength } from '../../../shared/testNumberWithDotLength'
import { IMPACT_STAGES, FLAG_FIELDS, DQS_FIELDS } from './utils'

const flagFields = FLAG_FIELDS.reduce((acc, key) => {
  acc[key] = Yup.number()
    .transform(transformNumberValueAllowZero)
    .typeError('Field accepts numbers only')
    .required('Field is required')
    .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)
  return acc
}, {})

const dqsFields = DQS_FIELDS.reduce((acc, key) => {
  acc[key] = Yup.number()
    .transform(transformNumberValueAllowZero)
    .typeError('Field accepts numbers only')
    .required()
    .min(1, 'DQS should be between 1 and 5')
    .max(5, 'DQS should be between 1 and 5')
  return acc
}, {})

const carbonFieldDef = Yup.number()
  .transform(transformNumberValueAllowZero)
  .typeError('Field accepts numbers only')
  .required('Carbon is required')
  .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)

const landUseFieldDef = Yup.number()
  .transform(transformNumberValueAllowZero)
  .typeError('Field accepts numbers only')
  .required('Land use is required')
  .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)

const eutrophicationFieldDef = Yup.number()
  .transform(transformNumberValueAllowZero)
  .typeError('Field accepts numbers only')
  .required('Eutrophication is required')
  .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)

const biodiversityFieldDef = Yup.number()
  .transform(transformNumberValueAllowZero)
  .typeError('Field accepts numbers only')
  .required('Biodiversity is required')
  .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)

const waterUsageFieldDef = Yup.number()
  .transform(transformNumberValueAllowZero)
  .typeError('Field accepts numbers only')
  .required('Water usage is required')
  .test('len', 'Max symbols allowed - 32. Max symbols after dot - 16', testNumberWithDotLength)

const impactSchema = IMPACT_STAGES.reduce((acc, key) => {
  acc[key] = Yup.object().shape({
    carbon: carbonFieldDef,
    landUse: landUseFieldDef,
    waterUsage: waterUsageFieldDef,
    biodiversity: biodiversityFieldDef,
    eutrophication: eutrophicationFieldDef,
  })
  return acc
}, {})

export const formSchema = Yup.object().shape({
  // Product Info tab fields
  name: Yup.string().required('Generic name is a required field').nullable(true),
  productType: Yup.number()
    .typeError('Field accepts numbers only')
    .min(0, 'Please select product type')
    .required()
    .integer(),
  productId: Yup.number()
    .typeError('Field accepts numbers only')
    .min(0, 'Please select product type')
    .required()
    .integer(),
  productCategoryId: Yup.number().typeError('Please select product category').integer().required(),
  productGroupId: Yup.number().when('productType', {
    is: (val: number) => val === 3,
    then: Yup.number().typeError('Please select product group').integer().required(),
    otherwise: Yup.number().nullable(true),
  }),
  productionSystem: Yup.number().when('productType', {
    is: (val: number) => val === 0,
    then: Yup.number().min(1, 'Please select production system').required(),
    otherwise: Yup.number().nullable(true),
  }),
  isBom: Yup.boolean().required(),
  referenceInformation: Yup.string().nullable(true),

  // Impacts tab fields
  ...impactSchema,

  // FLAG emissions tab fields
  flag: Yup.object().shape(flagFields),

  // DQS tab fields
  dqs: Yup.object().shape(dqsFields),
})
